import { Component, Input } from '@angular/core';
import { AbstractAuditDto, AuditViewDto } from '../../../service/dto';

@Component({
	selector: 'app-audit-timeline-view',
	standalone: false,
	templateUrl: './audit-timeline-view.component.html',
	styleUrl: './audit-timeline-view.component.scss'
})
export class AuditTimelineViewComponent {
	list!: AuditViewDto[];

	@Input()
	set audits(input: AbstractAuditDto[]){
		this.list = input.map(item => item as AuditViewDto);
	}
}
